import { useState, useEffect } from 'react';

function calculateCount(body) {
  return body.blocks.reduce((acc, block) => {
    if (block.type === 'paragraph' || block.type === 'header') {
      let text = block.data.text;
      text = text.replace(/<[^>]*>/g," ");
      text = text.replace(/\s+/g, ' ');
      text = text.replace(/&nbsp;/g, ' ');
      text = text.trim();

      const words = text.split(' ');

      return {
        characteres: acc.characteres + text.length,
        characteresWithoutSpaces: acc.characteresWithoutSpaces + text.replace(/\s/g, '').length,
        words: acc.words + words.length,
        paragraphs: acc.paragraphs + 1,
      };
    }

    return acc;
  }, {
    characteres: 0,
    characteresWithoutSpaces: 0,
    words: 0,
    paragraphs: 0,
  });
}

export default function PostCharactersCounter({ post }) {
  const [count, setCount] = useState({
    characteres: 0,
    characteresWithoutSpaces: 0,
    words: 0,
    paragraphs: 0,
  });

  useEffect(() => {
    if (!post.body) {
      return;
    }

    try {
      const data = JSON.parse(post.body);
      setCount(calculateCount(data));
    } catch (err) {
      console.error(err);
    }
  }, [post.body]);

  return (
    <div id="characters-counter">
      <div className="count">
        Caracteres: <span className="number">{count.characteres}</span>
      </div>
      <div className="count">
        Caracteres (sin espacios):{' '}
        <span className="number">
          {count.characteresWithoutSpaces}
        </span>
      </div>
      <div className="count">
        Palabras: <span className="number">{count.words}</span>
      </div>
      <div className="count">
        Párrafos: <span className="number">{count.paragraphs}</span>
      </div>
    </div>
  );
};
